export enum PrimeOptions {
  AssuranceScolaire = 'RCS',
  ProtectionJuridique = 'PJ',
  ProtectionJuridiqueSOL = 'PJSOL',
  ProtectionNomades = 'ANO',
  ProtectionVelos = 'VELO',
  ObjetsValeur = 'OBJVAL',
  ValeurANeuf = 'VAN',
  Vol = 'VLX'
}
